export default __webpack_public_path__ + "static/g103-147d0c299a37f20de807b37af1e6a3cc.jpg";